﻿﻿﻿
<iframe title="Market Query Power BI Report"
        style="height: 85vh; display: block; width: -webkit-fill-available"
        src="https://app.powerbi.com/reportEmbed?reportId=cc311a20-cd22-4d15-ae49-6d1162175a8d&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546"
        frameborder="0"
        allowFullScreen="true">
</iframe>

